<section class="area-login animate__animated animate__fadeIn" [ngStyle]="{ 'background-image': 'url(' + randomImage + ')' }">
  <div class="home-wrapper">

    <div class="home-header animate__animated animate__fadeIn">
      <div class="avatar-wrap">
        <img *ngIf="has_avatar == true"
          class="ejecutive_img"
          [src]="avatar">
        <div *ngIf="has_avatar == false"
          class="my-avatar">
          <span id="avatar">{{ user.charAt(0) }}</span>
        </div>
      </div>
      <h1 class="titulo-simpli">Bienvenido(a) {{user}}</h1>
      <p class="subtitulo-simpli">Seleccione una opción para navegar</p>
    </div>

    <div class="loading-wrap" *ngIf="loading == true">
      <mat-spinner diameter="40" style="opacity: 0.5;"></mat-spinner>
    </div>

    <div class="cards-grid" *ngIf="loading == false">

      <app-log-system
        *ngFor="let i of aux; let idx = index"
        [initials]="i.short"
        [url]="i.url"
        [name]="i.name"
        [style.animation-delay]="(idx * 40) + 'ms'"
        class="card-appear"
        (click)="navegar(i.short, i.name, i.url)">
      </app-log-system>

      <div class="logout-card card-appear" [style.animation-delay]="(aux.length * 40) + 'ms'" (click)="logout()">
        <div class="logout-icon-wrap">
          <span class="material-icons" style="font-size: 18px;">logout</span>
        </div>
        <div class="logout-label">Cerrar Sesión</div>
      </div>

    </div>

  </div>
</section>
